import { doc, deleteDoc, updateDoc, writeBatch, query, where, getDocs, collection } from 'firebase/firestore'
import { db } from '../../config/firebase'

export const deletePhotoUpload = async (photoUploadId: string): Promise<void> => {
  const batch = writeBatch(db)

  // Delete the photo upload document
  const photoUploadRef = doc(db, 'photoUploads', photoUploadId)
  batch.delete(photoUploadRef)

  // Delete related access codes
  const accessCodesQuery = query(
    collection(db, 'accessCodes'),
    where('photoUploadId', '==', photoUploadId)
  )
  const accessCodesSnapshot = await getDocs(accessCodesQuery)
  
  accessCodesSnapshot.docs.forEach(accessDoc => {
    batch.delete(accessDoc.ref)
  })

  await batch.commit()
}

// New function to delete only access codes, not the photo upload document
export const deleteAccessCode = async (accessCodeId: string): Promise<void> => {
  const accessCodeRef = doc(db, 'accessCodes', accessCodeId)
  await deleteDoc(accessCodeRef)
}

// New function to delete all access codes for a photo upload without deleting the photo upload
export const deleteAllAccessCodesForPhotoUpload = async (photoUploadId: string): Promise<void> => {
  const batch = writeBatch(db)

  // Find and delete all related access codes
  const accessCodesQuery = query(
    collection(db, 'accessCodes'),
    where('photoUploadId', '==', photoUploadId)
  )
  const accessCodesSnapshot = await getDocs(accessCodesQuery)
  
  accessCodesSnapshot.docs.forEach(accessDoc => {
    batch.delete(accessDoc.ref)
  })

  await batch.commit()
}

export const updatePhotoUploadStatus = async (
  photoUploadId: string, 
  status: 'active' | 'completed' | 'cancelled'
): Promise<void> => {
  const photoUploadRef = doc(db, 'photoUploads', photoUploadId)
  await updateDoc(photoUploadRef, {
    status,
    updatedAt: new Date().toISOString()
  })
} 